const MenuList = [
  {
    fullDesc: "Main Menu",
    shortDesc: "Menu",
    children: [
      {
        fullDesc: "Quick-start guide",
        shortDesc: "Quick-start guide",
      },
      {
        fullDesc: "Pre-test",
        shortDesc: "Pre-test",
      },
      {
        fullDesc: "Training menu",
        shortDesc: "Training menu",
        children: [
          {
            fullDesc: "Introduction",
            shortDesc: "Introduction",
          },
          {
            fullDesc: "Happiness",
            shortDesc: "Happiness",
          },
          {
            fullDesc: "Contempt",
            shortDesc: "Contempt",
          },
          {
            fullDesc: "Disgust",
            shortDesc: "Disgust",
          },
          {
            fullDesc: "Anger",
            shortDesc: "Anger",
          },
          {
            fullDesc: "Sadness",
            shortDesc: "Sadness",
          },
          {
            fullDesc: "Fear",
            shortDesc: "Fear",
          },
          {
            fullDesc: "Surprise",
            shortDesc: "Surprise",
          },
          {
            fullDesc: "How to spot Micro Expressions?",
            shortDesc: "Traning: Expressions",
          },
          {
            fullDesc: "How to see lies?",
            shortDesc: "Traning: Lies",
          },
          {
            fullDesc: "Cautions",
            shortDesc: "Cautions",
          },
          {
            fullDesc: "Questions & Answers",
            shortDesc: "Questions & Answers",
          },
          {
            fullDesc: "More resources to exercise",
            shortDesc: "",
          },
        ],
      },
      {
        fullDesc: "Practice - slow speed",
        shortDesc: "Practice - slow speed",
      },
      {
        fullDesc: "Practice - for beginners (only hap, con, dis)",
        shortDesc: "Practice - for beginners",
      },
      {
        fullDesc: "Practice - normal speed",
        shortDesc: "Practice - normal speed",
      },
      {
        fullDesc: "Practice - 2x speed",
        shortDesc: "Practice - 2x speed",
      },
      {
        fullDesc: "Practice - listening",
        shortDesc: "Practice - listening",
      },
      {
        fullDesc: "Practice - muted",
        shortDesc: "Practice - muted",
      },
      {
        fullDesc: "Practice - speaking",
        shortDesc: "Practice - speaking",
      },
      {
        fullDesc: "Practice - new videos",
        shortDesc: "Practice - new videos",
      },
      {
        fullDesc: "Practice - children",
        shortDesc: "Practice - children",
      },
      {
        fullDesc: "Practice - advanced combinations in 4K",
        shortDesc: "Practice - 4K combinations",
      },
      {
        fullDesc: "Practice - Impact movie excerpts",
        shortDesc: "Practice - Impact movie excerpts",
      },
      {
        fullDesc: "Test",
        shortDesc: "Test",
      },
      {
        fullDesc: "Next Steps",
        shortDesc: "",
      },
    ],
  },
];

export default MenuList;
